import Flex from 'components/Flex'
import styled from 'styled-components'

export const MainDiv = styled(Flex)`
 display: flex;
  align-items: center;
  justify-content: space-between; /
width: 100%;
height:63px;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  flex-direction: row;
  padding-bottom: 20px;
  padding-right: 20px;
  background-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#02457A33'
    }
  }};
  border-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};

  margin-top: -8px;
  margin-bottom: 20px;

  ;
`
export const TimeDiv = styled(Flex)`
 display: flex;
  align-items: center;
  justify-content: space-between; /
width: 100%;
height:101px;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  flex-direction: row;
  padding-bottom: 20px;
  padding-right: 20px;
  background-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#02457A33'
    }
  }};
  border-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};

  margin-top: -8px;
  margin-bottom: 20px;
  

  ;
`

export const StyledText = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: ${props => props.color || '#717171'};
  margin-top: 15px;
  width: 192px;
`
export const DynamicPart = styled.span`
  font-family: ${props => props.fontFamily || 'inherit'};
`

export const Duration = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  color: ${props => props.color || 'black'};
  padding: 36px 56px 20px 38px;
  flex: no-wrap;
  width: 192px;
`

export const VerticalDivider = styled.div`
  height: 28px;
  border-left: 1.3px solid #02457a;
  margin-top: 15px;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const VerticalDividerAction = styled.div`
  height: 28px;
  border-left: 1.3px solid #02457a;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const VerticalDivider1 = styled.div`
  height: 41px;
  border-left: 1.3px solid #02457a;
  margin-top: 15px;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const StyledText1 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  padding: 27px 7px 11px 35px;
  width: 405px;
`

export const Container = styled.div`

  gap: 10px
  margin-top:-20px;
  width: 100%;
`
export const StyledText2 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  padding-top: 16px;
  margin-right: 93px;
`
export const Part1 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
`

export const Part2 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
`

export const Date2 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 10px;
  margin-left: -188px;
  margin-top: 39px;
  width: 161px;
  flex: none;
`
export const Date1 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 10px;
  margin-left: -151px;
  margin-top: 39px;
  width: 161px;
  flex: none;
`
export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid #ccc; // Customize the border color
  margin: 20px 0; // Customize the margin
  width: 100%; // Customize the width
`

export const Regenddate = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${props => props.color || '#717171'};
  padding: 20px;
  padding-left: 43px;
  padding-right: 56px;
  flex: none;
`
export const Location = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${props => props.color || '#717171'};
  padding: 20px;
  padding-left: 38px;
  padding-right: 56px;
  flex: none;
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const IconsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-left: auto;
`

export const Icon = styled.div`
  cursor: pointer;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px; // Set the width to an appropriate size
  height: 40px; // Set the height to an appropriate size
  border: none;
  border-radius: 5px;
`
